import React, { useEffect, useRef } from "react";
import { GET_SERVICES } from "../graphql/queries";
import { useQuery } from "@apollo/client";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Services() {
    const { loading, error, data } = useQuery(GET_SERVICES);
    const serviceRefs = useRef([]);

    useEffect(() => {
        if (data) {
            serviceRefs.current.forEach((el, index) => {
                gsap.fromTo(
                    el,
                    { opacity: 0, y: 20 },
                    {
                        opacity: 1,
                        y: 0,
                        scrollTrigger: {
                            trigger: el,
                            start: "top 80%",
                            end: "bottom 60%",
                            toggleActions: "play none none none",
                        },
                        duration: 1,
                        delay: index * 0.2,
                    }
                );
            });
        }
    }, [data]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error: {error.message}</p>;
    }

    return (
        <div className="service-list">
            {data.services.map((service, index) => (
                <div
                    key={service.id}
                    ref={(el) => (serviceRefs.current[index] = el)}
                >
                    <p className="service-item">{service.title}</p>
                </div>
            ))}
        </div>
    );
}
